import * as cons from './constants';
import * as apis from './apis';
import { requestActionMaker } from '../helper';

export const getPaymentDetail = para => requestActionMaker({ cons: cons.GET_PAYMENT_DETAIL, api: apis.getPaymentDetail, ...para });
export const payInvoiceByPaypal = para => requestActionMaker({ cons: cons.PAY_INVOICE_BY_PAYPAL, api: apis.payInvoiceByPaypal, ...para });